module.exports = __webpack_public_path__ + "media/images/emoticons/notes-f6ed8a69fb1eafff51067fbefbff651a.gif";